export const EVENT_ACTION = "ACTION_EVENT";
export const EVENT_DELETED = "DELETED_EVENT";
export const EVENT_MOVED = "MOVED_EVENT";
export const EVENT_REDRAW = "REDRAW_EVENT";
export const EVENT_NEW = "NEW_EVENT";
export const EVENT_LOADED = "LOADED_EVENT";
export const EVENT_LOADING = "LOADING_EVENT";
export const EVENT_UPDATED = "UPDATED_EVENT";
export const EVENT_SAVED = "SAVED_EVENT";
export const EVENT_CHANGED = "CHANGED_EVENT";

export const EVENT_SWITCH_MODE = "SWITCH_MODE_EVENT";

export const EVENT_EXTERNAL_FLOORPLAN_LOADED =
  "EXTERNAL_FLOORPLAN_LOADED_EVENT";
export const EVENT_NEW_ITEM = "NEW_ITEM_EVENT";
export const EVENT_ITEM_REMOVED = "ITEM_REMOVED_EVENT";

export const EVENT_MODE_RESET = "MODE_RESET_EVENT";

export const EVENT_ROOM_NAME_CHANGED = "CHANGED_ROOM_NAME_EVENT";
export const EVENT_ROOM_FACTOR_CHANGED = "CHANGED_ROOM_FACTOR_EVENT";

export const EVENT_NEW_ROOMS_ADDED = "ADDED_NEW_ROOMS_EVENT";

export const EVENT_CORNER_ATTRIBUTES_CHANGED =
  "CORNER_ATTRIBUTES_CHANGED_EVENT";
export const EVENT_WALL_ATTRIBUTES_CHANGED = "WALL_ATTRIBUTES_CHANGED_EVENT";
export const EVENT_ROOM_ATTRIBUTES_CHANGED = "ROOM_ATTRIBUTES_CHANGED_EVENT";
export const EVENT_ROOM_METADATA_CHANGED = "ROOM_METADATA_CHANGED_EVENT";

export const EVENT_CORNER_CLICKED = "CORNER_CLICKED_EVENT";
export const EVENT_WALL_CLICKED = "WALL_CLICKED_EVENT";
export const EVENT_ROOM_CLICKED = "ROOM_CLICKED_EVENT";
export const EVENT_UNSELECTED = "UNSELECTED_EVENT";
export const EVENT_SELECTED = "SELECTED_EVENT";
export const EVENT_NOTHING_SELECTED = "NOTHING_SELECTED_EVENT";

export const EVENT_SELECTED_LABEL = "SELECTED_LABEL_EVENT";

export const EVENT_WALL_DIMENSION_CLICKED = "WALL_DIMENSION_CLICKED_EVENT";
export const EVENT_ROOM_DIMENSION_CLICKED = "ROOM_DIMENSION_CLICKED_EVENT";
export const EVENT_ICONS_CLICKED = "ICONS_CLICKED_EVENT";
export const EVENT_LABEL_CLICKED = "LABEL_CLICKED_EVENT";
export const EVENT_ARROW_CLICKED = "ARROW_CLICKED_EVENT";
export const EVENT_TRANSLATE_CLICKED = "TRANSLATE_CLICKED_EVENT";

export const EVENT_KEY_PRESSED = "KEY_PRESSED_EVENT";
export const EVENT_KEY_RELEASED = "KEY_RELEASED_EVENT";

export const EVENT_BOUNDARY_UPDATE = "BOUNDARY_UPDATE_EVENT";
